import { useMediaQuery } from '@chakra-ui/react';
import { theme } from '../../assets/style/theme';

function LineBreakOnDesktop() {
  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <br style={{ display: `${isMobile ? 'none' : 'inline'}` }} />
  );
}

export default LineBreakOnDesktop;
